import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { MatDialog } from '@angular/material/dialog';
import { GroupHasContentService } from '@services/groups/group-has-content.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { DynamicContentEntranceSelectionComponent } from './dynamic-content-entrance-selection/dynamic-content-entrance-selection.component';
import * as _ from 'lodash';
import { MyOrganisationService } from '@services/organisations/my-organisation.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { GroupService } from '@services/groups/group.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';

@Component({
    selector: 'app-group-content-manager',
    templateUrl: './group-content-manager.component.html',
    styleUrls: ['./group-content-manager.component.scss'],
    providers: [GroupHasContentService, GroupHasRoleInOrganisationService,
        MyOrganisationService, DynamicContentEntranceService, GroupService, PackageInstalledAppsService],
    standalone: false
})
export class GroupContentManagerComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  title = 'Group Has Content Management';
  dataProviderParams: any;
  pageActions: PageAction[];
  columns = [{ prop: 'title' }, { prop: 'dynamicContentEntrance_Id' }];
  tableData = [];

  selectedGroupId: string;

  organisationIds = [];
  assignedEntranceIds = [];

  validRole = false;

  constructor(
    private router: Router, private groupHasContentService: GroupHasContentService, private groupService: GroupService, private messengerService: MessengerService,
    private groupHasRolesInOrganisationsService: GroupHasRoleInOrganisationService, private myOrganisationService: MyOrganisationService, private dialog: MatDialog,
    private dynamicContentEntranceService: DynamicContentEntranceService, private packageInstalledAppsService: PackageInstalledAppsService, private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.selectedGroupId = this.route.snapshot.params['id'];
    this.groupService.get(this.selectedGroupId).then(group => {
      this.title = !!group ? 'Manage Content of Group: ' + group.name : this.title;
    });
    this.groupHasRolesInOrganisationsService.find(0, 100, { GroupID: this.selectedGroupId }).then(result => {
      result.data.map(ghr => {
        if (ghr.roleName === 'contentAuthor') { // if this role is missing - we can not use group has content model
          this.organisationIds.push(ghr.OrganisationID);
          this.validRole = true;
        }
      })
    });
    this.initTableData();
    this.createPageActions();
  }

  initTableData() {
    this.tableData = [];
    this.assignedEntranceIds = [];
    this.groupHasContentService.find(0, 100, { Groups_GroupID: this.selectedGroupId }).then(contents => {
      this.assignedEntranceIds = contents.data.map(el => el['dynamicContentEntrance_Id']);
      this.packageInstalledAppsService.find(0, 100, { dynamicContentEntranceId: { $in: this.assignedEntranceIds } }).then(apps => {
        contents.data.map(item => {
          item['title'] = apps.data.find(app => app.dynamicContentEntranceId === item.dynamicContentEntrance_Id)
            .translations
            .find(translation => translation.language === 'de').appTitle;
          return item;
        });
        this.tableData = contents.data;
      });
    });
  }

  addContent() {
    const dialogRef = this.dialog.open(DynamicContentEntranceSelectionComponent, {
      data: {
        organisationIds: this.organisationIds,
        assignedEntranceIds: this.assignedEntranceIds
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result._id) {
        const data = new Models.GroupHasContent();
        data.populateFromJSON({
          Groups_GroupID: this.selectedGroupId,
          dynamicContentEntrance_Id: result._id,
          type: 'write' // todo could be read too
        });
        this.groupHasContentService.create(data).then(() => {
          this.initTableData();
          this.table.refresh();
        });
      }
    })
  }

  onDelete(event: any) {
    this.groupHasContentService.remove(event.row.GroupHasContentID).then(() => {
      this.initTableData();
      this.table.refresh();
    });
  }

  navigateToEntrance(event: any) {
    this.dynamicContentEntranceService.get(event.row.dynamicContentEntrance_Id).then(entrance => {
      this.myOrganisationService.get(entrance.OwnerOrganisationID).then(organisation => {
        if (!organisation) {
          console.log('not allowed');
          return;
        }
        this.messengerService.setOrganisation(organisation);
        setTimeout(() =>
          this.router.navigate([{ outlets: { org: organisation.name, primary: 'dynamic-content' } }],
            { queryParams: { entranceId: event.row._id } }
          ), 1);
      });
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Detail',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id']]);
        }
      })
    ];
  }

}
